import React, { useState, useEffect, useContext, createContext } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
// contexts
import { useAuth } from '../Auth';
import { SettingsContext } from '../Settings';
// services
import { getTimeEntries, getEntries } from '../../services/Report';
// helper
import { getTimeZoneDate } from '../../helpers/Util';

export const ReportEntryContext = createContext();

ReportEntryProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default function ReportEntryProvider({ children }) {
  const [searchParams] = useSearchParams();
  const [entries, setEntries] = useState();
  const [entriesPerTime, setEntriesPerTime] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [eventDate, setEventDate] = useState(null);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const { authUser } = useAuth();
  const { authSettings } = useContext(SettingsContext);

  useEffect(() => {
    const fetchData = async (eventId) => {
      setIsLoading(true);

      try {
        setEventDate(null);
        setStart(null);
        setEnd(null);

        let eventDate = null;
        let start = null;
        let end = null;

        const queryEventDate = searchParams.get('eventDate');
        const queryDateStart = searchParams.get('start');
        const queryDateEnd = searchParams.get('end');

        if (queryEventDate) {
          eventDate = getTimeZoneDate({ date: queryEventDate }).toISOString();
          setEventDate(eventDate);
        }
        if (queryDateStart) {
          start = getTimeZoneDate({ date: queryDateStart }).toISOString();
          setStart(start);
        }
        if (queryDateEnd) {
          end = getTimeZoneDate({ date: queryDateEnd }).toISOString();
          setEnd(end);
        }

        const idToken = await authUser.getIdToken();
        const headers = {
          Authorization: `Bearer ${idToken}`,
          'Account-Key': authSettings.server.path
        };

        const entries = await getEntries({ headers, eventId, eventDate, start, end });

        const entriesPerTime = await getTimeEntries({
          headers,
          eventId,
          eventDate,
          start,
          end
        });

        setEntries(entries);
        setEntriesPerTime(entriesPerTime);
        setIsLoading(false);
      } catch (error) {
        setHasError(true);
        console.error(error);
      }
    };

    const eventId = searchParams.get('eventId');
    if (eventId) {
      fetchData(eventId);
    }
  }, [searchParams, authUser, authSettings, setEntries]);

  return (
    <ReportEntryContext.Provider
      value={{ entries, entriesPerTime, isLoading, hasError, eventDate, start, end }}
    >
      {children}
    </ReportEntryContext.Provider>
  );
}
